import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import accountSelectors from '@selectors/account';
import restaurantSelectors from '@selectors/restaurant';
import { getCacheAccessToken, getCacheIsAdmin, setCacheX_tenant } from '@services/userService';
import { restaurantActions } from '@store/actions';

import useActionLoading from './useActionLoading';
import useFetchAction from './useFetchAction';

const useRestaurant = (immediateDetail = false) => {
    const restaurant = useSelector(restaurantSelectors.selectMyRestaurant);
    const profile = useSelector(accountSelectors.selectProfile);
    const detailRestaurant = useSelector(restaurantSelectors.selectDetailRestaurant);
    const token = getCacheAccessToken();

    const params = useParams();
    const init = useRef(true);
    const [callbackApi, setCallbackApi] = useState(true);
    const { execute } = useFetchAction(restaurantActions.getMyRestaurant);
    const isAdmin = getCacheIsAdmin();
    useEffect(() => {
        if (!!token && !restaurant && profile && init && !isAdmin) {
            execute({
                params: { accountId: profile?.id, size: 999 },
            });
            init.current = false;
        }
    }, [token, restaurant, profile]);

    const restaurantId = params?.restaurantId;
    const X_TENANT = restaurant?.find((item) => item?.id == restaurantId)?.tenantId;

    useEffect(() => {
        if (X_TENANT) {
            setCacheX_tenant(X_TENANT);
        }
    }, [restaurantId]);
    const handleCallbackApi = () => {
        setCallbackApi(!callbackApi);
    };
    const { execute: executeDetailMyRestaurant } = useFetchAction(restaurantActions.getDetailRestaurant, {});
    useEffect(() => {
        if (immediateDetail && restaurantId) {
            executeDetailMyRestaurant({ pathParams: { id: restaurantId } });
        }
    }, [restaurantId, callbackApi]);
    const { loading } = useActionLoading(restaurantActions.getMyRestaurant.type);
    const settingRestaurant = detailRestaurant?.settings && JSON.parse(detailRestaurant?.settings);
    const currentSettingParse = {
        id: restaurant?.id,
        name: restaurant?.restaurantName,
        happuHours: settingRestaurant?.happy_hours_settings || [],
        printers: settingRestaurant?.printers || [],
        currentcy: settingRestaurant?.currentcy,
        currentcy_position: settingRestaurant?.currentcy_position,
        decimal_separator: settingRestaurant?.decimal_separator,
        group_separator: settingRestaurant?.group_separator,
    };
    return {
        restaurant,
        loading: loading,
        setting: settingRestaurant,
        currentSettingParse,
        handleCallbackApi,
    };
};

export default useRestaurant;
